'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withForm = require('constructicon/with-form');

var _withForm2 = _interopRequireDefault(_withForm);

var _form = require('./form');

var _form2 = _interopRequireDefault(_form);

var _errors = require('../../utils/errors');

var _oauth = require('../../utils/oauth');

var _params = require('../../utils/params');

var _window = require('../../utils/window');

var _authentication = require('../../api/authentication');

var _button = require('constructicon/button');

var _button2 = _interopRequireDefault(_button);

var _buttonGroup = require('constructicon/button-group');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _form3 = require('constructicon/form');

var _form4 = _interopRequireDefault(_form3);

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _gridColumn = require('constructicon/grid-column');

var _gridColumn2 = _interopRequireDefault(_gridColumn);

var _icon = require('constructicon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _inputField = require('constructicon/input-field');

var _inputField2 = _interopRequireDefault(_inputField);

var _jgLogo = require('./jg-logo');

var _jgLogo2 = _interopRequireDefault(_jgLogo);

var _section = require('constructicon/section');

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JGConnectForm = function (_React$Component) {
  _inherits(JGConnectForm, _React$Component);

  function JGConnectForm(props) {
    _classCallCheck(this, JGConnectForm);

    var _this = _possibleConstructorReturn(this, (JGConnectForm.__proto__ || Object.getPrototypeOf(JGConnectForm)).call(this, props));

    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleSuccess = _this.handleSuccess.bind(_this);
    _this.showOAuth = _this.showOAuth.bind(_this);

    _this.state = {
      errors: [],
      status: 'empty',
      confirming: false,
      method: 'signup',
      showButtons: props.showButtons
    };
    return _this;
  }

  _createClass(JGConnectForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var redirectUri = this.props.redirectUri;

      var data = (0, _params.parseUrlParams)();

      (0, _oauth.listenForPostMessage)({ redirectUri: redirectUri, onSuccess: this.handleSuccess });

      if (data.access_token || data.code) {
        return this.handleSuccess(data);
      }
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.setState({ status: 'empty' });
    }
  }, {
    key: 'handleSuccess',
    value: function handleSuccess(data) {
      var _this2 = this;

      var onSuccess = this.props.onSuccess;
      var confirming = this.state.confirming;


      if (!confirming) {
        Promise.resolve().then(function () {
          return _this2.setState({ confirming: true });
        }).then(function () {
          return (0, _authentication.connectToken)(data);
        }).then(function (data) {
          return onSuccess(data);
        }).catch(function (error) {
          var errors = [{ message: (0, _errors.getErrorMessage)(error) }];
          _this2.setState({ errors: errors, status: 'failed', confirming: false });
        });
      }
    }
  }, {
    key: 'showOAuth',
    value: function showOAuth(forceSignUp, email) {
      var _this3 = this;

      var _props = this.props,
          clientId = _props.clientId,
          homeUrl = _props.homeUrl,
          oauthParams = _props.oauthParams,
          popup = _props.popup,
          redirectUri = _props.redirectUri;

      var isMobile = (0, _window.getIsMobile)();

      return Promise.resolve().then(function () {
        return _this3.setState({
          errors: [],
          method: forceSignUp ? 'signup' : 'login',
          status: 'fetching'
        });
      }).then(function () {
        return (0, _oauth.getConnectUrl)({
          clientId: clientId,
          email: email,
          forceSignUp: forceSignUp,
          homeUrl: homeUrl,
          redirectUri: redirectUri,
          oauthParams: oauthParams
        });
      }).then(function (url) {
        return popup && !isMobile ? (0, _oauth.showPopup)({ url: url, onClose: _this3.handleClose }) : window.location.href = url;
      }).catch(function (error) {
        var errors = [{ message: (0, _errors.getErrorMessage)(error) }];
        _this3.setState({ errors: errors, status: 'failed' });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          buttonProps = _props2.buttonProps,
          formComponent = _props2.formComponent,
          inputField = _props2.inputField,
          form = _props2.form,
          label = _props2.label;
      var _state = this.state,
          confirming = _state.confirming,
          errors = _state.errors,
          method = _state.method,
          showButtons = _state.showButtons,
          status = _state.status;

      var isLoading = confirming || status === 'fetching';
      var isTouched = showButtons !== this.props.showButtons;

      if (showButtons) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _section2.default,
            { tag: 'h3', spacing: { b: 0.5 } },
            label || _react2.default.createElement(
              'span',
              null,
              'Do you have an existing ',
              _react2.default.createElement(_jgLogo2.default, null),
              ' account?'
            )
          ),
          _react2.default.createElement(
            _buttonGroup2.default,
            null,
            _react2.default.createElement(
              _button2.default,
              _extends({
                disabled: isLoading,
                background: 'justgiving',
                foreground: 'light',
                onClick: function onClick() {
                  return _this4.showOAuth(false);
                }
              }, buttonProps),
              _react2.default.createElement(
                'span',
                null,
                'Yes, I do'
              ),
              isLoading && method === 'login' && _react2.default.createElement(_icon2.default, { name: 'loading', spin: true })
            ),
            _react2.default.createElement(
              _button2.default,
              _extends({
                disabled: isLoading,
                background: 'justgiving',
                foreground: 'light',
                onClick: function onClick() {
                  return _this4.showOAuth(true);
                }
              }, buttonProps),
              _react2.default.createElement(
                'span',
                null,
                'No, I don\'t'
              ),
              isLoading && method === 'signup' && _react2.default.createElement(_icon2.default, { name: 'loading', spin: true })
            )
          ),
          _react2.default.createElement(
            _section2.default,
            { tag: 'p', spacing: { t: 0.5 } },
            _react2.default.createElement(
              'button',
              { onClick: function onClick() {
                  return _this4.setState({ showButtons: false });
                } },
              'I\'m not sure'
            )
          )
        );
      }

      return _react2.default.createElement(
        _form4.default,
        _extends({
          errors: errors,
          isLoading: isLoading,
          noValidate: true,
          onSubmit: function onSubmit(e) {
            e.preventDefault();

            form.submit().then(function (values) {
              return Promise.resolve().then(function () {
                return _this4.setState({ status: 'fetching', errors: [] });
              }).then(function () {
                return (0, _authentication.checkAccountAvailability)(values.email);
              }).then(function (hasAccount) {
                return _this4.showOAuth(!hasAccount, values.email);
              });
            });
          },
          submit: '',
          autoComplete: 'off'
        }, formComponent),
        _react2.default.createElement(
          _section2.default,
          { tag: 'h3', spacing: { b: 0.5 } },
          _react2.default.createElement(
            'label',
            { htmlFor: 'email' },
            label || _react2.default.createElement(
              'span',
              null,
              'Enter your email below to check if you have an existing',
              ' ',
              _react2.default.createElement(_jgLogo2.default, null),
              ' account'
            )
          )
        ),
        _react2.default.createElement(
          _grid2.default,
          { spacing: { x: 0.25, y: 0 } },
          _react2.default.createElement(
            _gridColumn2.default,
            { md: 9 },
            _react2.default.createElement(_inputField2.default, _extends({
              autoFocus: isTouched
            }, form.fields.email, inputField))
          ),
          _react2.default.createElement(
            _gridColumn2.default,
            { md: 3 },
            _react2.default.createElement(
              _button2.default,
              _extends({
                block: true,
                background: 'justgiving',
                disabled: isLoading,
                foreground: 'light',
                type: 'submit'
              }, buttonProps),
              _react2.default.createElement(
                'span',
                null,
                'Next'
              ),
              isLoading ? _react2.default.createElement(_icon2.default, { name: 'loading', spin: true }) : _react2.default.createElement(_icon2.default, { name: 'chevron' })
            )
          ),
          isTouched && _react2.default.createElement(
            _gridColumn2.default,
            null,
            _react2.default.createElement(
              'button',
              { onClick: function onClick() {
                  return _this4.setState({ showButtons: true });
                } },
              'Go back'
            )
          )
        )
      );
    }
  }]);

  return JGConnectForm;
}(_react2.default.Component);

JGConnectForm.propTypes = {
  /**
   * Props to be passed to the Button component
   */
  buttonProps: _propTypes2.default.object,

  /**
   * The JG application key
   */
  clientId: _propTypes2.default.string,

  /**
   * Props to be passed to the Form component
   */
  formComponent: _propTypes2.default.object,

  /**
   * Home URL that our oauth handler (oauth.blackbaud-sites.com) will redirect to
   */
  homeUrl: _propTypes2.default.string,

  /**
   * Props to be passed to the InputField components
   */
  inputField: _propTypes2.default.object,

  /**
   * The label at the top of the form
   */
  label: _propTypes2.default.string,

  /**
   * Options to customise the oauth flow - see https://github.com/JustGiving/JG.IdentityAndAccess.Sso/blob/master/src/JG.IdentityAndAccess.Sso.Core/IdentityAndAccess/Models/SingleSignOnOptionsModel.cs
   */
  oauthParams: _propTypes2.default.object,

  /**
   * The function to call when user is successfully authenticated
   */
  onSuccess: _propTypes2.default.func,

  /**
   * Use a popup window for OAuth
   */
  popup: _propTypes2.default.bool,

  /**
   * The url to redirect to on successful authentication
   */
  redirectUri: _propTypes2.default.string,

  /**
   * Show Yes/No buttons instead of an email check form
   */
  showButtons: _propTypes2.default.bool
};

JGConnectForm.defaultProps = {
  clientId: '44f34c65',
  popup: true,
  homeUrl: (0, _window.getCurrentUrl)(),
  redirectUri: 'https://oauth.blackbaud-sites.com/'
};

exports.default = (0, _withForm2.default)(_form2.default)(JGConnectForm);